import { ComponentsOverrides, Theme } from '@mui/material';

export const MuiCssBaseline: { styleOverrides?: ComponentsOverrides<Theme>['MuiCssBaseline'] } = {
    styleOverrides: {
        html: {
            fontFeatureSettings: '"ss01"',
            '& #root': {
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
            },
        },
        body: {
            scrollbarColor: '#2C93F0 transparent', // FireFox
            '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
                width: 5,
            },
            '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
                borderRadius: 2.5,
                backgroundColor: '#2C93F0',
            },
            '&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track': {
                backgroundColor: '#D5DFEB',
                borderRadius: 2.5,
            },
            minHeight: '100vh',
        },
        '@font-face': {
            fontFamily: 'Inter',
            fontStyle: 'oblique 0deg 10deg',
            fontWeight: '100 900',
            fontDisplay: 'block',
            src: "url('assets/fonts/Inter-VariableFont_slnt,wght.ttf')",
        },
        strong: {
            fontWeight: 600,
        },
        b: {
            fontWeight: 600,
        },
    },
};
